import { RoleTypeEnum } from 'api/account/membership/dtos';
import { LoadingPage } from 'components/loaders';
import { AuthGuard } from 'components/router/auth-guard/AuthGuard';
import { RoleGuard } from 'components/router/role-guard/RoleGuard';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from 'routes';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { Providers } from './Providers';

const PaymentPage = lazyWithRetry(() => import('pages/payment/Payment'));
const RegisterPage = lazyWithRetry(() => import('pages/register/Register'));
const TabletView = lazyWithRetry(() => import('views/tablet-view/TabletView'));
const BusinessView = lazyWithRetry(() => import('views/business-view/BusinessView'));
const UserView = lazyWithRetry(() => import('views/user-view/UserView'));
const BookingView = lazyWithRetry(() => import('views/booking-view/BookingView'));

function App() {
  return (
    <Providers>
      <Routes>
        <Route
          path={routes.register.route}
          element={
            <Suspense fallback={<LoadingPage />}>
              <RegisterPage />
            </Suspense>
          }
        />
        <Route
          path={routes.book.route}
          element={
            <Suspense fallback={<LoadingPage />}>
              <BookingView />
            </Suspense>
          }
        />
        <Route
          path={routes.payment.route}
          element={
            <Suspense fallback={<LoadingPage />}>
              <PaymentPage />
            </Suspense>
          }
        />
        <Route
          path={'/*'}
          element={
            <AuthGuard>
              <Suspense fallback={<LoadingPage />}>
                <RoleGuard allowed={[null]}>
                  <UserView />
                </RoleGuard>
                <RoleGuard allowed={[RoleTypeEnum.USER, RoleTypeEnum.OWNER]}>
                  <BusinessView />
                </RoleGuard>
                <RoleGuard allowed={[RoleTypeEnum.PUBLIC]}>
                  <TabletView />
                </RoleGuard>
              </Suspense>
            </AuthGuard>
          }
        />
      </Routes>
    </Providers>
  );
}

export default App;
